<template>
  <el-main :style="{height:height+'px'}">
    <div class="Scroll_content"  >
      <div>

        <div class="simkeropl">{{$t('new_test4.Schedule_a_Class')}}</div>
        <div class="text_jianjie">{{$t('new_test4.Sch_content')}}</div>
        <div class="zk">
            <img class="txqq" src="../../assets/Ellipse395.svg" alt="">

            <div class="maimaa">{{user_info.name}}</div>
            <div class="inntxta">({{user_info.describe}})</div>

            <div class="sin_boimn">
              <img class="immkkll" src="../../assets/Message.svg" alt="">
              <div class="ziticol">{{user_info.email}}</div>
            </div>
            <div class="sin_boimn">
              <img class="immkkll" src="../../assets/Stroke1.svg" alt="">
              <div class="ziticol">{{user_info.mobile}}</div>
            </div>
            <div class="sin_boimn">
              <img class="immkkll wx" src="../../assets/WeChat_lgo_icon1.svg" alt="">
              <div class="ziticol" style="margin-left:24px;"> {{user_info.wechat}}</div>
              <!-- <span class="zitimm">{{$t('new_test4.Wechat_ID')}}:</span> -->
            </div>
            <img class="ewm_img" :src="user_info.qr_code" alt="">
        </div>

        <div class="dian"></div>
      </div>
    </div>
  </el-main>
  
</template>
<script>
  import { setStore, getStore, keys } from '@/store';
  import IndexHeader from '../views/header'
  import IndexFooter from '../views/footer'
  import MyScheduled from '../views/scheduled'
  import MyCourse from '../views/course'
  import PastLesson from '../views/lesson'

  //引入header组件
  import Header from '../header/header'

  export default {
    components: {
      IndexHeader,
      IndexFooter,
      MyScheduled,
      PastLesson,
      MyCourse,
      Header
    },
    data () {
      return {
        height:100,
        user_info:[]
      }
    },
    created () {
      let height = document.body.offsetHeight-123;
      this.height = height


      this.Sales_information();

    },
    methods: {
      /**
       * 获取销售信息
       */
      Sales_information:function(){
        // console.log('测试：',navigator.language)
        // let _lan = (navigator.language == 'zh-CN')?'zh_CN': 'en'
        this.$http.get('/api/getUserInfo', {headers: {token:getStore(keys.token)}}).then((res) => {
          if (res.data.code == 200) {
            setStore(keys.user, res.data.data)
            this.user_info = res.data.data.salesperson_info
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      }
    },
    mounted () {

    },
    watch: {

    },
  }
</script>
<style lang="less" scoped>

.el-main{
  overflow: inherit;
}
.simkeropl{
    font-family: Sofia Pro;
    font-style: normal;
    font-weight: bold;
    font-size: 33px;
    color: #000000;
    text-align: center;

}
.text_jianjie{
    width: 400px;
    font-family: Poppins;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 20px;
    color: #0B1D33;
    text-align: center;
    margin: 20px auto 0 auto;
}
.zk{
    width: 549px;
    // height: 551px;
    background: #FFFFFF;
    border: 1px solid rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
    margin: 30px auto 0 auto;
}
.Scroll_content{
    border:0px solid red;
}
.txqq{
    width: 85px;
    height:85px;
    margin: 50px auto 0 auto;
    display: block;
}
.maimaa{
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 20px;
  color: #0B1D33;
  text-align: center;
  margin-top:8px;
}
.inntxta{
  // font-family: Poppins;
  font-style: normal;
  // font-weight: 600;
  font-size: 14px;
  text-align: center;
  color: #0B1D33;
  text-align: center;
  margin-top:8px;
    margin-bottom:30px;
}
.sin_boimn{
width: 362px;
    /* height: 40px; */
    border: 0px solid red;
    margin: 0 auto 30px auto;
    overflow: hidden;
}
.immkkll{
    width: 21.22px;
    height: 19.1px;
    float: left;
    margin-top: 5px;
}
.ziticol{
    font-family: Poppins;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    color: #0B1D33;
    margin-left: 31.78px;
    float: left;
}
.wx{
  width: 29.86px !important;
  height: 25px !important;
}
.zitimm{
  font-family: Poppins !important;
  font-style: normal !important;
  font-weight: normal !important;
  font-size: 16px !important;
  line-height: 20px !important;
  color: #0B1D33 !important;
}
.ewm_img{
    width: 106px;
    height: 106px;
    margin: 0 auto 20px auto;
    display: block;
    border:5px solid #4B69FE;
    border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/children/ScheduleaClass.vue